import React from 'react';

const LayoutContext = React.createContext({
  windowInnerHeight: 0,
  appBarHeight: 0,
  windowInnerWidth: 0,
});

export default LayoutContext;
